import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Logo } from "@/components/Logo";
import { OrbitMotif } from "@/components/OrbitMotif";
import { Loader2 } from "lucide-react";
import { extractErrorCode } from "@/lib/api";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { loginWithEmergent } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/auth", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(m[1]);

    (async () => {
      try {
        await loginWithEmergent(sessionId);
        // Clear hash and go to dashboard
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/dashboard", { replace: true });
      } catch (err) {
        setError(extractErrorCode(err));
        setTimeout(() => navigate("/auth", { replace: true }), 2500);
      }
    })();
  }, [location, loginWithEmergent, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#05073B]" data-testid="auth-callback-page">
      <OrbitMotif className="absolute inset-0 h-screen w-screen" color="#9ACD32" opacity={0.1} />
      <div className="relative text-center">
        <Logo size="lg" inverted />
        <div className="mt-12 flex items-center justify-center gap-3 text-slate-300">
          {!error ? (
            <>
              <Loader2 className="h-5 w-5 animate-spin text-[#9ACD32]" />
              <span className="text-sm">Authenticating…</span>
            </>
          ) : (
            <span className="text-sm text-red-300">Authentication failed. Redirecting…</span>
          )}
        </div>
      </div>
    </div>
  );
}
